import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import IncidentTypesActions, { IncidentTypesRedux, IncidentTypesTypes } from '../Redux/IncidentTypes'

const IncidentTypesCRUDObservable = createCRUDObservable({
  mainRedux: IncidentTypesRedux,
  reduxPath: 'incidentTypes',
})

export const IncidentTypesObservers = Object.assign({}, IncidentTypesCRUDObservable.observers, {})


export const IncidentTypesEpic = combineEpics(
  IncidentTypesCRUDObservable.epic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/IncidentTypesObservable.js